// Default map style - light blue water
export const defaultMapStyles = [
    {
      "featureType": "water",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#66d1e6"
        },
        {
          "weight": 1
        }
      ]
    }
];

// World Map View style - grey land, white ocean, grey continent outline (Copernicus-like)
export const worldMapStyles = [
    // Water - White ocean/background
    {
      "featureType": "water",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#ffffff"  // White for ocean water
        }
      ]
    },
    // No coastline rule here on purpose: Google accepts "water" + "geometry.stroke"
    // but never draws it. The coastline comes from the contrast between the grey
    // landmass and the white ocean, and MapComponent draws the continent outline
    // as a data layer on top so it survives the overlays.
    // Land - Grey color
    {
      "featureType": "landscape",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#e8e8e8"  // Grey for landmass
        }
      ]
    },
    // Administrative borders (country, province, ...) - Hidden. The client wants
    // the continent outline only, no borders inside the landmass.
    {
      "featureType": "administrative",
      "elementType": "geometry",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    // Hide labels for cleaner look
    {
      "featureType": "all",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    // Hide roads for cleaner look
    {
      "featureType": "road",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    // Hide POIs for cleaner look
    {
      "featureType": "poi",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    }
];

// Export default as customMapStyles for backward compatibility
export const customMapStyles = defaultMapStyles;
